<template>
    <div class="header">
        <div class="top-banner">
            <div class="img"><a href="/client/mypage"><img class="logo" src="@/asserts/BR_LOGO.png"></a></div>
            <div class="title">{{ commonIdName }}</div>
        </div>
    </div>
</template>

<script>
    import {CommonConstant} from "@/common-constant";

    export default {
        name: "Header",
        data: function () {
            return {
                commonIdName: CommonConstant.COMMON_ID_NAME
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "src/common-css";

    .header {
        background-color: $bg-dark-gray;
        color: $font-gray;
        .img {
            height: 30px;
        }
    }

    // PC
    @media screen and (min-width:768px) {
        .top-banner {
            height: 80px;
            display: flex;
            padding-left: 20px;
            .img { line-height: 100px; }
            .title {
                line-height: 85px;
                padding: 0px 0px 0px 20px;
            }

        }
    }

    // SP
    @media screen and (max-width:767px) {
        .top-banner {
            height: 45px;

            display: flex;
            text-align: center;
            vertical-align: middle;
            .img {
              line-height:57px;
              margin: 0 10px 0 10px;
            }
            .logo {
              width: 140px;
              height: auto;
            }
            .title {
                line-height: unset;
                font-size: 10px;
                margin-top: 15px;
            }
        }
    }
</style>